
import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 发布捐赠物资信息
 * @returns 
 */
export const getNoticeList = (noticeType: number, pageNum: number, pageSize: number): any => {
    return axios.get(`${baseURL}/Notice?noticeType=${noticeType}&pageNum=${pageNum}&pageSize=${pageSize}`)
}

/**
 * 发布捐赠物资信息
 * @returns 
 */
export const delNotice = (id: string): any => {
    return axios.delete(`${baseURL}/Notice/${id}`)
}

/**
 * 获取新的消息通知数量
 * @returns 
 */
 export const getNewNoticeCount = (time: number): any => {
    return axios.get(`${baseURL}/Notice/GetNewNoticeCount?time=${time}`)
}

/**
 * 获取新的消息通知数量-商城，我的消息
 * @returns 
 */
 export const GetShopNewNoticeCount = (time: number): any => {
    return axios.get(`${baseURL}/Notice/GetShopNewNoticeCount?time=${time}`)
}

/**
 * 最新消息类型
 * @returns 
 */
export const getNewType = (): any => {
    return axios.get(`${baseURL}/Notice/GetNewType`)
}



/**
 * 我的消息，商城的
 * @returns 
 */
export const getNoticeMyShop = (pageNum: number, pageSize: number): any => {
    return axios.get(`${baseURL}/Notice/MyShop?pageNum=${pageNum}&pageSize=${pageSize}`)
}

